/**
 * Sound files the Emergency alarm plays, in rotation: first alarm beat plays the
 * first file, the next beat the second, and so on round the list.
 *
 * Drop the files in `public/sounds/` and name them here, path and all:
 *
 *   export const ALARM_SOUNDS: readonly string[] = ['/sounds/alarm-1.mp3', '/sounds/alarm-2.mp3'];
 *
 * Leave the list empty and the alarm falls back to the two-tone beep it
 * synthesises itself. It also falls back, per file, for anything that fails to
 * load or decode — an operator never gets a silent Emergency because a file
 * went missing from a deploy.
 *
 * Each clip plays out in full — the next beat waits for it — so a clip may be
 * any length. Mute still cuts the playing clip short. Paths are absolute, from
 * the site root: a relative one resolves against the current route, and on a
 * nested route the SPA fallback answers with index.html, which fails to decode
 * and silently drops the clip from the rotation.
 */
export const ALARM_SOUNDS: readonly string[] = [
  '/sounds/fahhhhhhhhhhhhhh.mp3',
  '/sounds/vaste-gana-hoiyeinnn.mp3',
  '/sounds/gopgopgop.mp3',
  '/sounds/makabhosda_aag.mp3',
];
